export default [
  {
    path: 'laborOutsourcing/socialInsurance/details',
    component: () => import('@/views/socialInsuranceManage/socialInsuranceReport/SocialInsuranceDetails'),
    name: 'SocialInsuranceDetails',
    meta: { title: '社保明细', icon: 'a-up', noCache: true },
    hidden: true
  },
  // {
  //   path: 'laborOutsourcing/need/importBatch',
  //   component: () => import('@/views/hrManage/outsourcedNeed/importBatch'),
  //   name: 'LaborOutsourcingNeedImportBatch',
  //   meta: { title: '导入外包人员', icon: 'a-up', noCache: false },
  //   hidden: true
  // },
  {
    path: 'laborOutsourcing/need/importRecord',
    component: () => import('@/views/hrManage/outsourcedNeed/importRecord'),
    name: 'LaborOutsourcingNeedImportRecord',
    meta: { title: '导入记录', icon: 'a-up', noCache: false },
    hidden: true
  },
  {
    path: 'laborOutsourcing/need/details',
    component: () => import('@/views/hrManage/outsourcedNeed/details'),
    name: 'LaborOutsourcingNeedDetails',
    meta: { title: '名单明细', icon: 'a-up', noCache: false },
    hidden: true
  },
  {
    path: 'laborOutsourcing/bill/billDetail/:id',
    component: () => import('@/views/laborOutsourcing/bill/billDetail'),
    name: 'billSettleDetail',
    meta: { title: '账单明细', icon: 'a-up', noCache: true },
    hidden: true
  }
]
